<div class="component-details payment-details">
  <fourd-component-header [expert]="expert()" (close)="onClose()"></fourd-component-header>
  <div class="component-column">
    <div class="component-panel payment_header">
      <div>
        <h4>{{resources?.PaymentOptionsHeading}}</h4>
        @if (paymentLoading) {
        <div class="generic-loader">
          <i><svg><use href="#icon-wait"></use></svg></i>
        </div>
        } @else {
        <div>
          @if (hasRegisteredCard) {
          <p>You have a saved payment card (<a (click)="manageCard()">{{currentCardNumberPartial}}</a>)</p>
          } @else {
          <p>You do not have an active payment card. To enable top-ups please <a (click)="manageCard()">add one now</a>.</p>
          }
        </div>
        }
      </div>
      <div>
        <p>Your account balance is <span>{{member()?.AvailableBalance?.AmountFormatted}}</span></p>
      </div>
    </div>
    <div class="component-column component-panel payment_options">
      <h4>Selected {{resources?.ReadingFirstUpperCase}}</h4>
      @if (productList) {
      <div>
        @for (product of productList; track product?.ProductId) {
        <div class="grid-payment-panel">
          @if(isMultiProduct()){
          <div class="multi-product-left-half">
            <input type="radio"
                   name="product"
                   [value]="product"
                   [checked]="isSelectedProduct(product)"
                   (change)="selectedProductChanged(product)" />
          </div>
          }
          <div [class]="isMultiProduct() ? 'multi-product-right-half' : 'single-product'">
            <fourd-product-display [product]="product"></fourd-product-display>
          </div>
        </div>
        }
      </div>
      @if (config()?.IsTestSystem && isBundleProduct(selectedProduct)) {
      <div>
        <div class="component-column component-panel balance-card">
          <div class="balance-card-row">
            <span class="balance-label">Available Balance</span>
            <span class="balance-amount">{{member()?.AvailableBalance?.AmountFormatted}}</span>
          </div>
          <div class="balance-card-row">
            <input type="checkbox"
                   #balanceCheckbox
                   [checked]="useBalance"
                   (change)="calculateRemainingAmount(balanceCheckbox.checked)" />
            <span class="balance-amount">Use balance for this payment</span>
          </div>
          @if (useBalance && selectedProduct && remainingAmount > 0) {
          <div class="balance-card-row border-top">
            <span class="balance-label">Remaining to Pay:</span>
            <span class="balance-amount">{{remainingAmountFormatted}}</span>
          </div>
          }
        </div>
      </div>
      }
      <div>
        <div id="card-button">
          <a tabindex="0" class="component-button button-available review-button"
             [class.aspNetDisabled]="submittingData"
             (click)="requestPaymentV2($event)">
            @if (submittingData) {
            <span><i><svg><use href="#icon-wait"></use></svg></i></span>
            } @else {
            <span class="card-button-text">Pay by</span>
            }
            <svg class="visa"><use href="#icon-payment-visa"></use></svg>
            <svg class="mastercard"><use href="#icon-payment-mastercard"></use></svg>
          </a>
        </div>
        @if (config()?.ApplePayEnabled) {
        <div id="applepay-button" class="hidden"></div>
        }
        @if (config()?.GooglePayEnabled) {
        <div id="googlepay-button" class="hidden"></div>
        }
        @if (config()?.PayPalEnabled) {
        <div id="paypal-button" class="hidden"></div>
        }
      </div>
      } @else {
      <div>No products can be found, please try again</div>
      }
      @if (paymentLoading) {
      <div class="generic-loader">
        <i><svg><use href="#icon-wait"></use></svg></i>
      </div>
      }
    </div>
  </div>
  @if (modal) {
    <fourd-modal [modal]="modal"></fourd-modal>
  }
  @if (showManageCard) {
    <fourd-manage-card [expert]="expert()" [product]="selectedProduct" (close)="closeManageCard($event)"></fourd-manage-card>
  }
</div>
@if (paymentExecuting) {
  <div [class]="(modalDialog() ?'displayAsModal-dialog component-container displayAsModal-background':'component-container')">
    <div [class]="(modalDialog() ?'displayAsModal-content component-details paymentIframe-details':'component-details')">
      <a tabindex="0" class="close" (click)="onCloseIframe($event)"><span class="sr-only">close payment iframe window</span><i aria-hidden="true"><svg><use href="#icon-close"></use></svg></i></a>
      <div id="paymentIframe-frameContainer" class="clearfix">
        <iframe id="fourd_payment_frame" height="400" scrolling="no"></iframe>
      </div>
    </div>
  </div>
}
